module.exports = __webpack_public_path__ + "static/media/decor.c3da49ca.png";